<template>
  <slot :timeObj="timeObj" />
</template>

<script>
export default {
  name: 'CountdownTimer',
  props: {
    endTime: { type: Number, required: true }
  },
  emits: ['finish'],
  data () {
    return {
      timeObj: { m: '00', s: '00' },
      timer: null
    }
  },
  mounted () {
    this.tick()
    this.timer = setInterval(this.tick, 1000)
  },
  beforeUnmount () {
    clearInterval(this.timer)
  },
  methods: {
    tick () {
      const remaining = Math.max(0, this.endTime - Date.now())
      const totalSeconds = Math.floor(remaining / 1000)
      const m = Math.floor(totalSeconds / 60)
      const s = totalSeconds % 60
      this.timeObj = {
        m: String(m).padStart(2, '0'),
        s: String(s).padStart(2, '0')
      }
      if (remaining <= 0) {
        clearInterval(this.timer)
        this.$emit('finish')
      }
    }
  }
}
</script>
